import styled from 'styled-components';

export const Container = styled.div`
  &.MenuFromDots{
    position: relative;
  }
  &.Dots{
    width: 40px;
    //z-index: 10;
    text-align: center;
  }
`;

export const StyledImg = styled.img`
  cursor: pointer;
`;

export const StyledList = styled.ul`
  position: absolute;
  top: 0;
  right: 0;
  list-style-type: none;
  background: #fff;
  padding-left: 0;
  border-radius: 5px;
`;

export const StyledLi = styled.li`
  &.DeleteItem{
    color: #E85454;
  }
  &.error{
    color: #E85454;
  }
  padding: 17px 8px 12px 5px;
  width: 150px;
  text-align: center;
  position: relative;
  cursor: pointer;
  &:not(:last-child)::after{
    content: '';
    background: rgba(33, 33, 33, 0.08);
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
  }
  &:hover{
    background: #777;
  }
`;